export const height = {
  iconBaseRem: '1.5rem',
  none: 0,
};
export const width = {
  iconBaseRem: '1.5rem',
  none: 0,
};
